/**
 * Plan list + checkout: offer price vs regular (v2 + subscription list parity).
 * Catalog APIs may use `cost`/`offer_cost` or `price`/`amount`/`final_cost` for list and promos.
 */
function firstFiniteNumber(...values: unknown[]): number | null {
  for (const v of values) {
    if (v == null || v === '') {
      continue;
    }
    const n = Number(v);
    if (Number.isFinite(n) && !Number.isNaN(n)) {
      return n;
    }
  }
  return null;
}

export function resolvePlanOfferPricing(plan: { offer_cost?: unknown; cost?: unknown } & Record<string, unknown>): {
  displayPrice: number;
  strikethroughPrice: number | null;
} {
  const list = firstFiniteNumber(
    plan.cost,
    plan.price,
    (plan as { amount?: unknown }).amount,
    (plan as { final_cost?: unknown }).final_cost,
    (plan as { subscription_cost?: unknown }).subscription_cost,
    (plan as { original_cost?: unknown }).original_cost,
  );
  const offer = firstFiniteNumber(
    plan.offer_cost,
    (plan as { offer_price?: unknown }).offer_price,
    (plan as { discounted_price?: unknown }).discounted_price,
  );
  const cost_ok = list != null && list >= 0;
  const offer_is_valid = offer != null && offer > 0;
  if (cost_ok && offer_is_valid && list != null && offer < list) {
    return { displayPrice: offer, strikethroughPrice: list };
  }
  if (cost_ok && list != null) {
    return { displayPrice: list, strikethroughPrice: null };
  }
  if (offer_is_valid && offer != null) {
    return { displayPrice: offer, strikethroughPrice: null };
  }
  return { displayPrice: 0, strikethroughPrice: null };
}

export function getEffectivePlanUnitPrice(plan: { offer_cost?: unknown; cost?: unknown }): number {
  return resolvePlanOfferPricing(plan).displayPrice;
}
